import { useAuth } from "../../context/AuthContext";

function Dashboard() {
  const { admin, logout } = useAuth();

  return (
    <div className="container py-5">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h3>Welcome, {admin?.full_name}</h3>
        <button className="btn btn-outline-danger" onClick={logout}>
          <i className="bi bi-box-arrow-right me-1"></i> Logout
        </button>
      </div>
      <p className="text-muted">Role: {admin?.role}</p>
      <p>Dashboard content and sidebar coming next.</p>
    </div>
  );
}

export default Dashboard;
